import React, { useEffect, useState } from "react";
import api, { fmtErr } from "../../lib/api";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../ui/dialog";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "../ui/select";
import { toast } from "sonner";

const CATEGORIE = ["acquisto", "imposte e notaio", "agenzia", "progettazione e tecnici", "demolizioni e opere edili", "impianti", "finiture", "infissi", "cucine e arredi", "oneri comunali", "assicurazioni e sicurezza", "finanziario", "marketing e vendita", "altro"];

export default function AiRifiutaDialog({ inv, operations, onClose, onDone }) {
  const p = inv?.ai_proposta || {};
  const isVoce = p.livello === "voce";
  const [opId, setOpId] = useState("");
  const [voci, setVoci] = useState([]);
  const [bid, setBid] = useState("");
  const [nuova, setNuova] = useState({ voce: "", categoria: "altro" });
  const [busy, setBusy] = useState(false);
  useEffect(() => { setOpId(""); setBid(""); setNuova({ voce: "", categoria: "altro" }); }, [inv?.id]);
  useEffect(() => {
    if (inv && isVoce && inv.operation_id) api.get(`/operations/${inv.operation_id}/budget`).then((r) => setVoci((r.data?.items || r.data || []).filter((v) => v.id !== p.budget_item_id))).catch(() => setVoci([]));
  }, [inv?.id, isVoce]);

  const run = async (body, msg) => {
    setBusy(true);
    try { await api.post(`/ai/fatture/${inv.id}/rifiuta`, body); toast.success(msg); onDone(); onClose(); }
    catch (e) { toast.error(fmtErr(e.response?.data?.detail)); } finally { setBusy(false); }
  };
  const correzione = isVoce ? (bid === "nuova" ? (nuova.voce.trim() ? { nuova_voce: nuova } : null) : bid ? { budget_item_id: bid } : null) : opId ? { operation_id: opId } : null;

  return (
    <Dialog open={!!inv} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="ai-rifiuta-dialog">
        <DialogHeader><DialogTitle>Proposta AI sbagliata — qual è quella giusta?</DialogTitle></DialogHeader>
        <div className="text-xs text-muted-foreground">Fattura {inv?.numero} · {inv?.controparte?.denominazione}<br />{inv?.oggetto}</div>
        <div className="text-xs rounded bg-violet-50 border border-violet-200 px-2 py-1 text-violet-800">L'AI proponeva: {isVoce ? `voce «${p.voce_nome}»` : `operazione «${p.operazione_nome}»`}</div>
        {isVoce ? (
          <div className="space-y-2">
            <Label className="text-xs">Voce di budget corretta</Label>
            <Select value={bid} onValueChange={setBid}><SelectTrigger data-testid="ai-rifiuta-voce"><SelectValue placeholder="Scegli la voce…" /></SelectTrigger>
              <SelectContent>{voci.map((v) => <SelectItem key={v.id} value={v.id}>{v.voce}{v.categoria ? ` · ${v.categoria}` : ""}</SelectItem>)}<SelectItem value="nuova">+ Nuova voce…</SelectItem></SelectContent></Select>
            {bid === "nuova" && <div className="grid grid-cols-2 gap-2">
              <Input placeholder="Nome voce" value={nuova.voce} onChange={(e) => setNuova({ ...nuova, voce: e.target.value })} data-testid="ai-rifiuta-nuova-voce" />
              <Select value={nuova.categoria} onValueChange={(v) => setNuova({ ...nuova, categoria: v })}><SelectTrigger><SelectValue /></SelectTrigger><SelectContent>{CATEGORIE.map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}</SelectContent></Select>
            </div>}
          </div>
        ) : (
          <div className="space-y-2">
            <Label className="text-xs">Operazione corretta</Label>
            <Select value={opId} onValueChange={setOpId}><SelectTrigger data-testid="ai-rifiuta-operazione"><SelectValue placeholder="Scegli l'operazione…" /></SelectTrigger>
              <SelectContent>{operations.filter((o) => o.id !== p.operation_id).map((o) => <SelectItem key={o.id} value={o.id}>{o.nome_operazione}</SelectItem>)}</SelectContent></Select>
          </div>
        )}
        <p className="text-[11px] text-muted-foreground">Se scarti soltanto, la fattura passa in «da verificare» e l'AI ricorda di non riproporre questa scelta per questo fornitore con oggetti simili.</p>
        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={() => run({}, "Proposta scartata: fattura in «da verificare»")} disabled={busy} data-testid="ai-rifiuta-solo">Scarta soltanto</Button>
          <Button onClick={() => run(correzione, "Correzione applicata, regola appresa")} disabled={busy || !correzione} data-testid="ai-rifiuta-correggi">Applica e impara</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
